import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { Button, ButtonGroup, Card, CardBody, Row, Col, Input, Tooltip, Label } from 'reactstrap';
import { InputAnalyte } from './InputAnalyte';
import { InputImagenology } from './InputImagenology';
import { InputsMicro } from './InputsMicro';
import './styleCaptureResults.css';
import { PresumptiveResult } from './PresumptiveResult';
import { ComponentCommentGlobal } from './ComponentCommentGlobal';
import { PresumptiveSave } from './PresumptiveSave';
import { cedimi } from '../../../constant/globalConstantsTypeClients'
import { InputsCurves } from './InputsCurves';
import { Sidebar } from 'primereact/sidebar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Avatar } from '@mui/material';

export const ViewExam = ({

    // ! ANALYTE
    typeArray, sectionProfileId, examen, age, days_age, gender, saveIndividualAnalyte, releaseExam, validateAnalyte, validateExam, analytes, idPat, namePatiente, nameP, surnameP, surnameM, modal, toggle, curves = null,
    microBacteriums, addMicroAislado, microAntibiograms, previewWorkOrder, saveFileExamImagenology, handleGetDocumentImagenology,
    removeValidationFromExamOrProfile, updateMethod, setAnalytes, is_profile,

    // ? PRESUMTIVE RESULTS
    addPresumptiveResult, presumptive, setPresumptive, removePresumptiveResult,
    handleChangePresumptive, PrintingPresumptiveResult, cancelRemovePresumtiveResults, printingGlobal, cancelPrintingPresumptive, removePrintingGlobal,
    valdatePresumtiveResults, ReleasePresumtiveResults, unvalidatePresumtiveResults, unreleasePresumtiveResults,

    // ? BACTERIUM
    setMicroBacteriums, handleTypeBacterium, handleChangeComments,
    removeBacterium1, removeBacteriumAntibitic, ValidateBacterium, UnValidateBacterium, ReleaseBacterium, UnReleaseBacterium,
    setValidMicro,

    // ? COMMENT GLOBAL
    handleChangeIsolated, microComments, addCommentGlobal, handleChangeResult, handleTypeResult, toggleTableGlobalComment, modalTableGlobalComment, method,
    handleCreateGlobalComment, modalCrudComment, toggleCrudComment, saveCreate, handleInputChange, text, type, comments, handleInsert, handleDeleteCommentText, loading,
    search, setSearch, keyComments,

    // ? Refresh work order exam
    handleRefresh,

    //? CURVES
    listCurves, handleChangeCurveResult, handleChangeCurveTime, disabledInputFollowUp, handleResetResultCurves,

    // ?
    loadingValidate, loadingReleaseExam, loadingRemove, fetchExamMethodData, setListCurves, disableMethodInput,

    // appCodeOrMethodExam, setAppCodeOrMethodExam
    loadingValidateCapture, loadingReleaseExamCapture, loadingRemoveCapture, idWChart,
    enable_tracking_tomas, pyrsaClient, handleFullUnvalidate,
    getResultsHistory, selectedExam, visibleSidebar, historicoRaw, historicoData, setSelectedExam, setVisibleSidebar, setHistoricoRaw,
    setHistoricoData, handleHistorico, getUltimos3Nims, buildHistorico3, loadingHistorico, getNimsData, hasHistorico, historicoGlobal
}



) => {
    let enable_tracking_toma = localStorage.getItem('enable_tracking_toma');
    console.log("🚀 ~ ViewExam ~ examen:", examen)
    const getBranchProcess = () => {
        try {
            let json = localStorage.getItem("list_branch_storage");
            var branches = JSON.parse(json);
            var idx_branch = branches.findIndex(b => b.id_branch == parseInt(id_branch));
            if (idx_branch == -1) return [];
            else return branches[idx_branch].ids_branch_process;
        } catch (error) {
            return [];
        }
    }

    // * TYPE CLIEN
    let _typeClient = localStorage.getItem('url_helen');

    let id_branch = localStorage.getItem('branchId');
    let ids_branch_process = getBranchProcess() || [];
    let enable_interface_imagenology = localStorage.getItem('enable_interface_imagenology');
    enable_interface_imagenology = (enable_interface_imagenology == "true" ? true : false);

    const [examMethod, setExamMethod] = useState(0);
    const [readyToRelease, setReadyToRelease] = useState(false);
    const [riguroso, setRiguroso] = useState(false);
    const [releaseData, setReleaseData] = useState(null);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
    const [appCodeOrMethodExam, setAppCodeOrMethodExam] = useState(0);

    const replaceExamCurves = (idExam, newCurves) => {
        setListCurves(prevList =>
            prevList.map(exam => {
                if (String(exam.id_exam) === String(idExam)) {
                    const updatedCurves = newCurves.map(newCurve => {
                        const existingCurve = exam.curves.find(c => c.num_sampling === newCurve.num_sampling);
                        return {
                            ...newCurve,

                            name_unit: existingCurve?.name_unit,
                            num_decimals: existingCurve?.num_decimals,
                            captured_at: existingCurve?.captured_at || null,
                            id_user_capture: existingCurve?.id_user_capture || null,
                            validated_at: existingCurve?.validated_at || null,
                            released_at: existingCurve?.released_at || null,
                            result: existingCurve?.result || newCurve.result || null,
                        };
                    });
                    return { ...exam, curves: updatedCurves };
                }
                return exam;
            })
        );
    };

    const changeMethod = async ({ target }) => {
        const selectedMethodId = target.value; // El ID del método seleccionado

        const selectedMethod = examen.methods.find(x => x.id_exam_method == selectedMethodId);

        if (selectedMethod) {
            setExamMethod(selectedMethod.id_method);
            setAppCodeOrMethodExam(selectedMethod.id_exam_method);

            // Crear una copia modificada de la lista de 'analytes'
            const updatedAnalytes = analytes.map(item => {
                if (item.id_exam === examen.id_exam) {
                    return {
                        ...item,
                        id_app_code_or_method_exam: selectedMethod.id_exam_method
                    };
                }
                return item;
            });

            setAnalytes(updatedAnalytes);

            const apiData = await fetchExamMethodData(examen.id_work_order_exam, selectedMethod.id_method);

            if (apiData && Array.isArray(apiData.data)) {
                replaceExamCurves(examen.id_exam, apiData.data);
            } else {
                // console.warn("[changeMethod] No se recibieron curvas válidas de la API");
            }
        } else {
            // console.warn("[changeMethod] No se encontró método con id_exam_method:", selectedMethodId);
        }
    };


    const canReport = (id_branch_wo) => {
        if (parseInt(id_branch) == id_branch_wo) return true;
        else {
            var idx = ids_branch_process.findIndex(id => id == id_branch_wo);
            return (idx >= 0);
        }
    }

    useEffect(() => {
        let method = examen.methods.find(x => x.id_exam_method == examen.method_selected);
        if (method != undefined) {
            if (examen.method_selected !== null) {
                setExamMethod(method.id_method);
                setAppCodeOrMethodExam(examen.method_selected);
            } else {
                if (examen.methods.length > 0) {
                    if (examen.id_app_code_method_default !== null && examen.id_app_code_method_default !== undefined) {
                        let examen_default = examen.methods.find(x => x.id_exam_method === examen.id_app_code_method_default);
                        if (examen_default !== undefined && examen_default !== null) {
                            setExamMethod(examen_default.id_method);
                            setAppCodeOrMethodExam(examen_default.id_exam_method);
                        } else {
                            setExamMethod(examen.methods[0].id_method);
                            setAppCodeOrMethodExam(examen.methods[0].id_exam_method);
                        }
                    } else {
                        setExamMethod(examen.methods[0].id_method);
                        setAppCodeOrMethodExam(examen.methods[0].id_exam_method);
                    }
                }
            }
        } else {
            if (examen.methods.length > 0) {

                if (examen.id_app_code_method_default !== null && examen.id_app_code_method_default !== undefined) {

                    let examen_default = examen.methods.find(x => x.id_exam_method === examen.id_app_code_method_default);
                    if (examen_default !== undefined && examen_default !== null) {
                        setExamMethod(examen_default.id_method);
                        setAppCodeOrMethodExam(examen_default.id_exam_method);
                    } else {
                        setExamMethod(examen.methods[0].id_method);
                        setAppCodeOrMethodExam(examen.methods[0].id_exam_method);
                    }
                } else {
                    setExamMethod(examen.methods[0].id_method);
                    setAppCodeOrMethodExam(examen.methods[0].id_exam_method);
                }

            }

        }



        let validacion = true;
        let riguroso_validate = true;

        if (!enable_interface_imagenology && examen.is_imagenology) {
            if (examen.imagenology != null) {
                if (examen.imagenology.required) {
                    if (examen.imagenology.isCaptured === false) {
                        validacion = false;
                    }
                }
            }
            setReadyToRelease(validacion);
        }
        else if (!enable_interface_imagenology && !examen.is_imagenology) {
            if (examen.analytes !== null && examen.analytes.length > 0) {
                if (examen.analytes.filter(a => a.required).length == 0) {
                    validacion = false;
                    riguroso_validate = true;
                }

                examen.analytes.forEach(element => {
                    if (element.required) {
                        riguroso_validate = false;
                        if (element.isCaptured === false) {
                            validacion = false;
                            riguroso_validate = true;
                        } else {
                            if (validacion == false) {
                                riguroso_validate = true;
                            } else {
                                riguroso_validate = false;
                            }

                        }
                    } else {
                        riguroso_validate = false;


                    }

                });
            }
            setRiguroso(riguroso_validate);
            setReadyToRelease(validacion);
        }

        if (examen.isRelease) {
            let { user } = examen;
            // console.log("🚀 ~ useEffect ~ user:", user)
            let obj = {
                "date": examen.release_date,
                "user": (user === null || user === "") ? "N/A" : `${user?.name ?? "--"} ${user?.paternal_surname ?? "--"} ${user?.maternal_surname ?? "---"} / ${user?.username ?? "--"}`
            }
            setReleaseData(obj);
        }

    }, [])

    useEffect(() => {
        let validacion = true;
        let validacionExam = true;
        let riguroso_validate = true;
        // debugger;
        if (!enable_interface_imagenology && examen.is_imagenology) {
            if (examen.imagenology !== null) {
                if (examen.imagenology.required) {
                    if (examen.imagenology.isCaptured === false) {
                        validacion = false;
                        validacionExam = false;
                    }
                    if (examen.imagenology.userValidate === null) {
                        validacion = false;
                    }
                }

                setReadyToRelease(validacion);
                setReadyToValidate(validacionExam);
            }
        }
        else if (!enable_interface_imagenology && !examen.is_imagenology) {
            if (examen.analytes !== null && examen.analytes.length > 0) {
                if (examen.analytes.filter(a => a.required).length == 0) {
                    validacion = false;
                    validacionExam = false;
                    riguroso_validate = true;
                }

                examen.analytes.forEach(element => {
                    if (element.required) {
                        riguroso_validate = false;
                        if (element.isCaptured === false) {
                            validacion = false;
                            validacionExam = false;
                            riguroso_validate = true;
                        } else {
                            riguroso_validate = false;
                            if (validacion == true) {
                                riguroso_validate = false;
                            } else {
                                riguroso_validate = true;
                            }
                        }
                        if (element.userValidate === null) {
                            validacion = false;
                        }

                    } else {

                        riguroso_validate = false;

                    }
                });
            }

            setRiguroso(riguroso_validate);
            setReadyToRelease(validacion);
            setReadyToValidate(validacionExam);
        }
        else if (enable_interface_imagenology && !examen.is_imagenology) {
            examen.analytes !== null && examen.analytes.forEach(element => {
                if (element.required) {
                    riguroso_validate = false;
                    if (element.isCaptured === false) {
                        validacion = false;
                        validacionExam = false;
                        riguroso_validate = true;
                    } else {
                        riguroso_validate = false;
                        if (validacion == true) {
                            riguroso_validate = false;
                        } else {
                            riguroso_validate = true;
                        }
                    }
                    if (element.userValidate === null) {
                        validacion = false;

                    }

                } else {

                    riguroso_validate = false;

                }

            });


            setRiguroso(riguroso_validate);
            setReadyToRelease(validacion);
            setReadyToValidate(validacionExam);
        }

        if (examen.isRelease) {
            let { user } = examen;
            // console.log("🚀 ~ useEffect ~ user:", user)
            let obj = {
                "date": examen.release_date,
                "user": (user === null || user === "") ? "N/A" : `${user?.name ?? "-"} ${user?.paternal_surname ?? "-"} ${user?.maternal_surname ?? "-"} / ${user?.username ?? "-"}`
            }
            setReleaseData(obj);
        } else {
            setReleaseData(null)
        }

    }, [examen.imagenology, examen.analytes, examen.isRelease])


    const metodoSeleccionado = Array.isArray(examen.methods)
        ? examen.methods.find(met => Number(met.id_exam_method) === Number(appCodeOrMethodExam))
        : null;

    const tooltipText = metodoSeleccionado
        ? `Método: ${metodoSeleccionado.name}${metodoSeleccionado.name_machine ? ` (${metodoSeleccionado.name_machine})` : ""}`
        : "Método no encontrado";

    const [changed, setChanged] = useState(false);



    const renderHeaderNim = (label, nim) => {
        return (
            <>
                <div style={{ fontSize: "11px", color: "#ffffff" }}>
                    {label}
                </div>
                <div style={{ fontSize: "10px", fontWeight: "700", color: "#ffffff" }}>
                    {nim || "-"}
                </div>
            </>


        );
    };

    return (
        <Row>
            <Col sm="12">
                <Card className="shadow">
                    <CardBody className="p-3 pb-0">

                        <Row>
                            <Col sm="3" className='' >
                                <div className={!pyrsaClient ? "d-none" : ""} style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
                                    <i title={examen.check_forwarded ? "Con muestra" : "Sin muestra"} className={examen.check_forwarded ?
                                        "pi pi-exclamation-circle txt-success f-22 " :
                                        "pi pi-exclamation-circle txt-danger f-22 "
                                    }></i>
                                    <h6 style={{ margin: 0 }}>{examen.name}</h6>

                                </div>
                                <div className={!pyrsaClient ? "" : "d-none"} style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
                                    {/* {
                                        enable_tracking_toma === "True" &&
                                        <i title={examen.is_send3 ? "Proceso completo en analitica" : "Proceso incompleto de analitica"} className={examen.is_send3 ?
                                            "pi pi-exclamation-circle txt-success f-22 " :
                                            "pi pi-exclamation-circle txt-danger f-22 "
                                        }></i>
                                    } */}

                                    <h6 style={{ margin: 0 }}>{examen.name}</h6>

                                </div>
                            </Col>
                            <Col sm="3">
                                {
                                    (enable_interface_imagenology && examen.is_imagenology)
                                        ?
                                        examen.release_date === null ? "En espera de resultados" : "Resultados liberados"
                                        :
                                        (!enable_interface_imagenology && !examen.is_imagenology)
                                            ?
                                            (canReport(examen.id_branch))
                                                ?
                                                <Row>

                                                    <Col sm="11" className="custom-tooltip-wrapper">
                                                        <Input type='select' tabIndex="-1" className="form-control form-control-sm" onChange={changeMethod}
                                                            value={appCodeOrMethodExam} disabled={disableMethodInput ? true : (examen.id_estatus_exam != 1 && examen.id_estatus_exam != 2 && examen.id_estatus_exam != 3 ? true : false)}

                                                        >
                                                            {
                                                                examen.methods.map((metodo, key3) => {
                                                                    return <option style={{ backgroundColor: metodo.is_active !== true ? '#e9ecef' : 'inherit' }} key={key3} value={metodo.id_exam_method} disabled={metodo.is_active == true ? false : true}>Método: {metodo.name} {metodo.name_machine !== "" ? `(${metodo.name_machine})` : ""}</option>
                                                                })
                                                            }
                                                        </Input>
                                                        <div className="custom-tooltip">
                                                            {tooltipText}
                                                        </div>


                                                    </Col>


                                                    {/* <Col sm="1">
                                                   
                                                        <i onClick={ examen.release_date != null ? () => alert(examen.id_work_order_exam) : () => updateMethod(examen.id_work_order_exam)} className={examen.release_date!=null ? "disabled fa fa-refresh f-28 pointer text-primary" : "fa fa-refresh f-28 pointer text-primary"}></i>
                                                    </Col> */}
                                                </Row>

                                                :
                                                examen.is_internal_maquila
                                                    ?
                                                    examen.isRelease
                                                        ?
                                                        <Input type='select' tabIndex="-1" className="form-control form-control-sm" onChange={changeMethod} disabled={disableMethodInput ? true : (examen.id_estatus_exam != 1 && examen.id_estatus_exam != 2 && examen.id_estatus_exam != 3 ? true : false)} value={appCodeOrMethodExam}>
                                                            {
                                                                examen.methods.map((metodo, key3) => {
                                                                    return <option style={{ backgroundColor: metodo.is_active !== true ? '#e9ecef' : 'inherit' }} key={key3} value={metodo.id_exam_method} disabled={metodo.is_active == true ? false : true}>Método: {metodo.name} {metodo.name_machine !== "" ? `(${metodo.name_machine})` : ""}</option>
                                                                })
                                                            }
                                                        </Input>
                                                        : <p>El examen esta siendo procesado en {examen.name_branch}</p>
                                                    : <p>No tienes acceso para capturar el resultado</p>
                                            : ((enable_interface_imagenology && !examen.is_imagenology)) ?
                                                (canReport(examen.id_branch))
                                                    ?
                                                    <Input type='select' tabIndex="-1" className="form-control form-control-sm" onChange={changeMethod} disabled={disableMethodInput ? true : (examen.id_estatus_exam != 1 && examen.id_estatus_exam != 2 && examen.id_estatus_exam != 3 ? true : false)} value={appCodeOrMethodExam}>
                                                        {
                                                            examen.methods.map((metodo, key3) => {
                                                                return <option style={{ backgroundColor: metodo.is_active !== true ? '#e9ecef' : 'inherit' }} key={key3} value={metodo.id_exam_method} disabled={metodo.is_active == true ? false : true}>Método: {metodo.name} {metodo.name_machine !== "" ? `(${metodo.name_machine})` : ""}</option>
                                                            })
                                                        }
                                                    </Input>
                                                    :
                                                    examen.is_internal_maquila
                                                        ?
                                                        examen.isRelease
                                                            ?
                                                            <Input type='select' tabIndex="-1" className="form-control form-control-sm" onChange={changeMethod} disabled={disableMethodInput ? true : (examen.id_estatus_exam != 1 && examen.id_estatus_exam != 2 && examen.id_estatus_exam != 3 ? true : false)} value={appCodeOrMethodExam}>
                                                                {
                                                                    examen.methods.map((metodo, key3) => {
                                                                        return <option style={{ backgroundColor: metodo.is_active !== true ? '#e9ecef' : 'inherit' }} key={key3} value={metodo.id_exam_method} disabled={metodo.is_active == true ? false : true}>Método: {metodo.name} {metodo.name_machine !== "" ? `(${metodo.name_machine})` : ""}</option>
                                                                    })
                                                                }
                                                            </Input>
                                                            : <p>El examen esta siendo procesado en {examen.name_branch}</p>
                                                        : <p>No tienes acceso para capturar el resultado</p>
                                                : ""
                                }
                            </Col>
                            <br />
                            <Col sm="2" className='' >
                                <div className="custom-tooltip-wrapper">
                                    <img
                                        src={require("../../../assets/images/borrar.png")}
                                        alt="Excel"
                                        style={{ cursor: 'pointer', width: '25px', height: '25px' }}
                                        onClick={() => handleRefresh(examen.id_work_order_exam)}
                                    />
                                    <div className="custom-tooltip">
                                        Borrar Resultados
                                    </div>
                                </div>
                            </Col>

                            <Col sm="4" className='text-right'>
                                {
                                    canReport(examen.id_branch) && (

                                        <Button
                                            tabIndex="-1"
                                            onClick={() => handleHistorico(examen)}
                                            style={{
                                                background: "linear-gradient(135deg, #057cc8, #205579)",
                                                color: "#fff",
                                                border: "none",
                                                marginRight: "8px",
                                                borderRadius: "8px",
                                                padding: "6px 12px",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "6px"
                                            }}
                                        >
                                            <i className="pi pi-info-circle" />
                                            Histórico
                                        </Button>

                                    )
                                }
                                {
                                    (!enable_interface_imagenology && (!examen.is_imagenology))
                                        ?
                                        (canReport(examen.id_branch))
                                            ?
                                            <ButtonGroup tabIndex="-1">
                                                {
                                                    releaseData === null
                                                        ?
                                                        !readyToRelease && (
                                                            <Button tabIndex="-1" className={!readyToValidate ? "d-none" : ""} title={!readyToValidate ? "Guarde todos los resultados en rojo para poder validar toda la prueba" : ""} outline color="success" onClick={readyToValidate ? () => validateExam(examen.id_work_order_exam, examen.id_exam, typeArray, sectionProfileId) : null} disabled={loadingValidateCapture[examen.id_work_order_exam] === true}>
                                                                {loadingValidateCapture[examen.id_work_order_exam] ? (
                                                                    <span className="d-flex align-items-center">
                                                                        <i className="fa fa-spinner fa-spin mr-2" />
                                                                        Procesando..
                                                                    </span>
                                                                ) : (
                                                                    'Validar Prueba'
                                                                )}
                                                            </Button>
                                                        )
                                                        : ""
                                                }

                                                {
                                                    releaseData === null
                                                        ?
                                                        (readyToRelease && <>
                                                            <Button tabIndex="-1" className={riguroso == true ? 'd-none' : ""} onClick={() => removeValidationFromExamOrProfile(examen.id_work_order_exam)} color='danger' disabled={loadingRemoveCapture[examen.id_work_order_exam] === true} outline>
                                                                {loadingRemoveCapture[examen.id_work_order_exam] ? (
                                                                    <span className="d-flex align-items-center">
                                                                        <i className="fa fa-spinner fa-spin mr-2" />
                                                                        Procesando..
                                                                    </span>
                                                                ) : (
                                                                    'Desvalidar'
                                                                )}

                                                            </Button>


                                                            <Button tabIndex="-1" className={riguroso == true ? 'd-none' : ""} onClick={() => releaseExam(examen.id_work_order_exam, examen.id_exam)} color="primary" disabled={loadingReleaseExamCapture[examen.id_work_order_exam] === true}>

                                                                {loadingReleaseExamCapture[examen.id_work_order_exam] ? (
                                                                    <span className="d-flex align-items-center">
                                                                        <i className="fa fa-spinner fa-spin mr-2" />
                                                                        Procesando..
                                                                    </span>
                                                                ) : (
                                                                    'Liberar prueba'
                                                                )}


                                                            </Button>
                                                        </>)
                                                        :
                                                        <>
                                                            <Button tabIndex="-1" onClick={() => removeValidationFromExamOrProfile(examen.id_work_order_exam)} color='danger' disabled={loadingRemoveCapture[examen.id_work_order_exam] === true} outline>
                                                                {loadingRemoveCapture[examen.id_work_order_exam] ? (
                                                                    <span className="d-flex align-items-center">
                                                                        <i className="fa fa-spinner fa-spin mr-2" />
                                                                        Procesando...
                                                                    </span>
                                                                ) : (
                                                                    'Desvalidar'
                                                                )}

                                                            </Button>
                                                            <span style={{ display: "flex", alignItems: "center" }} className='badge badge-light-primary'><h6 className='p-0 m-0'>PRUEBA LIBERADA</h6></span>
                                                        </>
                                                }
                                            </ButtonGroup>
                                            :
                                            (releaseData === null)
                                                ?
                                                !readyToRelease ? <p>En espera de validación</p> : <p>En espera de liberación</p>
                                                : <h5>PRUEBA LIBERADA</h5>
                                        : (enable_interface_imagenology && (!examen.is_imagenology)) ?
                                            (canReport(examen.id_branch))
                                                ?
                                                <ButtonGroup tabIndex="-1">
                                                    {
                                                        releaseData === null
                                                            ?
                                                            !readyToRelease && (
                                                                <Button tabIndex="-1" className={!readyToValidate ? "d-none" : ""} title={!readyToValidate ? "Guarde todos los resultados en rojo para poder validar toda la prueba" : ""} outline color="success" onClick={readyToValidate ? () => validateExam(examen.id_work_order_exam, examen.id_exam, typeArray, sectionProfileId) : null} disabled={loadingValidateCapture[examen.id_work_order_exam] === true}>
                                                                    {loadingValidateCapture[examen.id_work_order_exam] ? (
                                                                        <span className="d-flex align-items-center">
                                                                            <i className="fa fa-spinner fa-spin mr-2" />
                                                                            Procesando..
                                                                        </span>
                                                                    ) : (
                                                                        'Validar Prueba'
                                                                    )}
                                                                </Button>
                                                            )
                                                            : ""
                                                    }

                                                    {
                                                        releaseData === null
                                                            ?
                                                            (readyToRelease && <Button tabIndex="-1" className={riguroso == true ? 'd-none' : ""} onClick={() => releaseExam(examen.id_work_order_exam, examen.id_exam)} color="primary" disabled={loadingReleaseExamCapture[examen.id_work_order_exam] === true}>

                                                                {loadingReleaseExamCapture[examen.id_work_order_exam] ? (
                                                                    <span className="d-flex align-items-center">
                                                                        <i className="fa fa-spinner fa-spin mr-2" />
                                                                        Procesando..
                                                                    </span>
                                                                ) : (
                                                                    'Liberar prueba'
                                                                )}

                                                            </Button>)

                                                            : <h5>PRUEBA LIBERADA</h5>
                                                    }
                                                </ButtonGroup>
                                                :
                                                (releaseData === null)
                                                    ?
                                                    !readyToRelease ? <p>En espera de validación</p> : <p>En espera de liberación</p>
                                                    : <h5>PRUEBA LIBERADA</h5>
                                            : ""
                                }
                            </Col>





                        </Row>
                        {
                            (examen.release_date !== null || (canReport(examen.id_branch) && examMethod > 0)) && Array.isArray(listCurves) && (
                                <InputsCurves
                                    listCurves={listCurves.filter(curveExam => curveExam.id_exam === examen.id_exam)}
                                    handleChangeCurveResult={handleChangeCurveResult}
                                    releaseData={releaseData}
                                    handleChangeCurveTime={handleChangeCurveTime}
                                    disabledInputFollowUp={disabledInputFollowUp}
                                    handleResetResultCurves={handleResetResultCurves}
                                    setChanged={setChanged}
                                />
                            )
                        }

                        {
                            !enable_interface_imagenology && examen.is_imagenology &&
                            <InputImagenology
                                dataExam={examen}
                                imagenologyData={examen.imagenology}
                                releaseData={releaseData}
                                saveFileExamImagenology={saveFileExamImagenology}
                                sectionProfileId={sectionProfileId}
                                handleGetDocumentImagenology={handleGetDocumentImagenology}
                            />
                        }
                        {
                            canReport(examen.id_branch) && examMethod > 0 &&
                            ((curves === null || curves === undefined) ?
                                <>
                                    {
                                        examen.analytes.map((analyte, key4) => {
                                            return <InputAnalyte
                                                analyteData={analytes.find(x => x.id == analyte.id_analyte) !== undefined ? analytes.find(x => x.id == analyte.id_analyte) :
                                                    {
                                                        "id": "",
                                                        "capture": "",
                                                        "id_exam": "",
                                                        "id_type_analyte": "",
                                                        "id_exam_method": "",
                                                        "decimals": "",
                                                        "compute": "",
                                                        "variable": "",
                                                        "comment": "",
                                                        "id_analyte_references": ""
                                                    }
                                                }
                                                changeMethod={changeMethod}
                                                dataExam={examen}
                                                validateAnalyte={validateAnalyte}
                                                releaseData={releaseData}
                                                saveIndividualAnalyte={saveIndividualAnalyte} examMethod={examMethod} appCodeOrMethodExam={appCodeOrMethodExam} age={age} days_age={days_age} gender={gender} analyte={analyte} key={key4} idPat={idPat} namePatiente={namePatiente} nameP={nameP} surnameP={surnameP} surnameM={surnameM}
                                                allCurves={"Esta entrando por aca"}
                                                previewWorkOrder={previewWorkOrder}
                                                setChanged={setChanged}
                                                idWChart={idWChart}
                                            />
                                        })
                                    }
                                    {/* <hr /> */}
                                    {
                                        examen?.is_micro && //!CAPTURE RESULTS
                                        <>
                                            {
                                                // * PRESUMPTIVE
                                            }
                                            {
                                                _typeClient !== cedimi && <Row className={examen?.presumptive_results?.length > 0 ? "d-none" : 'border-top pt-2 mt-2'}    >
                                                    <Col sm="12">
                                                        <h5>Resultados Preliminar</h5>
                                                        <button className='btn btn-warning' tabIndex="-1" onClick={() => addPresumptiveResult(examen?.id_work_order_exam, is_profile === true ? "profile" : "section", examen?.id_exam, sectionProfileId)}>Nuevo Preliminar</button>
                                                    </Col>
                                                </Row>
                                            }
                                            {
                                                _typeClient !== cedimi && <div className='p-l-0' style={{ backgroundColor: "#d1fdbf36" }}>
                                                    {
                                                        examen?.presumptive_results !== undefined && examen?.presumptive_results !== null ?
                                                            <>
                                                                {
                                                                    examen?.presumptive_results?.length > 0 && examen?.presumptive_results.map((_presumtive, _key) => (
                                                                        <>
                                                                            <PresumptiveSave
                                                                                idExam={examen?.id_work_order_exam}
                                                                                presumptive={presumptive}
                                                                                handleChangePresumptive={handleChangePresumptive}
                                                                                presumptive2={presumptive}
                                                                                printingGlobal={printingGlobal}
                                                                                removePrintingGlobal={removePrintingGlobal}
                                                                                typeArray={typeArray}
                                                                                sectionProfileId={sectionProfileId}
                                                                                examId={examen?.id_exam}
                                                                            />
                                                                            {
                                                                                _presumtive?.presumptives?.length > 0 && (
                                                                                    <PresumptiveResult
                                                                                        key={_presumtive?.presumptives[0]?.id_presumptive_result}
                                                                                        addPresumptiveResult={addPresumptiveResult}
                                                                                        setPresumptive={setPresumptive}
                                                                                        removePresumptiveResult={removePresumptiveResult}
                                                                                        idExam={examen?.id_work_order_exam}
                                                                                        position={_key}
                                                                                        presumptive={presumptive}
                                                                                        savePresuntive={_presumtive?.close_capture}
                                                                                        PrintingPresumptiveResult={PrintingPresumptiveResult}
                                                                                        cancelRemovePresumtiveResults={cancelRemovePresumtiveResults}
                                                                                        cancelPrintingPresumptive={cancelPrintingPresumptive}
                                                                                        valdatePresumtiveResults={valdatePresumtiveResults}
                                                                                        ReleasePresumtiveResults={ReleasePresumtiveResults}
                                                                                        unvalidatePresumtiveResults={unvalidatePresumtiveResults}
                                                                                        unreleasePresumtiveResults={unreleasePresumtiveResults}
                                                                                        typeArray={typeArray}
                                                                                        sectionProfileId={sectionProfileId}
                                                                                        examId={examen?.id_exam}
                                                                                    />
                                                                                )
                                                                            }
                                                                        </>
                                                                    ))
                                                                }
                                                            </>
                                                            : null
                                                    }
                                                </div>
                                            }
                                            {
                                                _typeClient !== cedimi &&
                                                <hr />
                                            }
                                            {
                                                // ? TYPE OF REPORT
                                            }
                                            {
                                            }
                                            {
                                                _typeClient === cedimi && <Row>
                                                    <Col sm="12" className='pb-4'>
                                                        <Row>
                                                            <Col sm="3">
                                                                <h5 className={examen?.cedimi_micro_type_result === false ? "txt-success" : ""}>Informe Preeliminar</h5>
                                                                <i
                                                                    style={examen?.id_estatus_exam === 4 || examen?.id_estatus_exam === 6 ? { filter: "opacity(0.5)" } : {}}
                                                                    className={examen?.cedimi_micro_type_result === false ? "fa fa-square f-26 icon-a-a txt-success" : "fa fa-square-o f-26 icon-a-a txt-success"}
                                                                    onClick={(e) => {
                                                                        if (examen?.id_estatus_exam === 4 || examen?.id_estatus_exam === 6) {
                                                                            e.preventDefault();
                                                                            return;
                                                                        }
                                                                        handleTypeResult(examen?.id_work_order_exam, is_profile === true ? "profile" : "section", examen?.id_exam, sectionProfileId, 0);
                                                                    }}></i>
                                                            </Col>
                                                            <Col sm="3">
                                                                <h5 className={examen?.cedimi_micro_type_result === true ? "txt-success" : ""}>Informe Final</h5>
                                                                <i
                                                                    style={examen?.id_estatus_exam === 4 || examen?.id_estatus_exam === 6 ? { filter: "opacity(0.5)" } : {}}
                                                                    className={examen?.cedimi_micro_type_result === true ? "fa fa-square f-26 icon-a-a txt-success" : "fa fa-square-o f-26 icon-a-a txt-success"}
                                                                    onClick={(e) => {
                                                                        if (examen.id_estatus_exam === 4 || examen.id_estatus_exam === 6) {
                                                                            e.preventDefault();
                                                                            return;
                                                                        }
                                                                        handleTypeResult(examen?.id_work_order_exam, is_profile === true ? "profile" : "section", examen?.id_exam, sectionProfileId, 1);
                                                                    }}></i>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            }


                                            <Row >
                                                <Col sm="12">
                                                    {
                                                        // * BACTERIUM
                                                    }
                                                    {
                                                        examen?.isRelease === false ?
                                                            <button className='btn btn-success' tabIndex="-1" onClick={() => addMicroAislado(examen?.id_work_order_exam, is_profile == true ? "profile" : "section")}>Nuevo microorganismo</button>
                                                            : ""
                                                    }
                                                </Col>
                                            </Row>
                                            <div style={{ paddingBottom: 40 }}>
                                                {
                                                    examen?.bacteriums !== undefined && examen?.bacteriums !== null && examen?.bacteriums.length > 0 ?
                                                        <>
                                                            {
                                                                microBacteriums.map((_bacter, _keys) => {
                                                                    return <InputsMicro
                                                                        key={_bacter?.id_mic_bacterium}
                                                                        idExam={examen?.id_work_order_exam}
                                                                        examId={examen?.id_exam}
                                                                        position={_keys}
                                                                        is_profile={is_profile}
                                                                        sectionProfileId={sectionProfileId}
                                                                        listMicroBacteriums={microBacteriums}
                                                                        microBacteriums={_bacter}
                                                                        setMicroBacteriums={setMicroBacteriums}
                                                                        handleTypeBacterium={handleTypeBacterium}
                                                                        microAntibiograms={microAntibiograms}
                                                                        handleChangeComments={handleChangeComments}
                                                                        removeBacterium1={removeBacterium1}
                                                                        removeBacteriumAntibitic={removeBacteriumAntibitic}
                                                                        ValidateBacterium={ValidateBacterium}
                                                                        typeArray={typeArray}
                                                                        UnValidateBacterium={UnValidateBacterium}
                                                                        ReleaseBacterium={ReleaseBacterium}
                                                                        UnReleaseBacterium={UnReleaseBacterium}
                                                                        _typeClient={_typeClient}
                                                                        cedimi={cedimi}
                                                                        handleCreateGlobalComment={handleCreateGlobalComment}
                                                                        handleFullUnvalidate={handleFullUnvalidate}
                                                                    />
                                                                })
                                                            }
                                                        </>
                                                        : ""
                                                }
                                            </div>

                                            <Row className={examen?.micro_global_comment?.length > 0 ? "d-none" : 'border-top pt-2 mt-2'}    >
                                                <Col sm="12">
                                                    <h5>Comentario Global</h5>
                                                    <button className='btn btn-dark' tabIndex="-1" onClick={() => addCommentGlobal(examen?.id_work_order_exam, is_profile === true ? "profile" : "section", examen?.id_exam, sectionProfileId)}>Nuevo Comentario</button>
                                                </Col>
                                            </Row>
                                            <div style={{ paddingBottom: 40 }}>
                                                {
                                                    // * GLOBAL COMMENT
                                                }
                                                {
                                                    examen?.micro_global_comment !== undefined && examen?.micro_global_comment !== null ?
                                                        <>
                                                            {
                                                                microComments.map((_comment, _key) => {
                                                                    return <ComponentCommentGlobal
                                                                        idExam={examen?.id_work_order_exam}
                                                                        microCommentss={_comment}
                                                                        typeArray={typeArray}
                                                                        sectionProfileId={sectionProfileId}
                                                                        examId={examen?.id_exam}
                                                                        handleChangeIsolated={handleChangeIsolated}
                                                                        valid={examen?.id_estatus_exam}
                                                                        handleChangeResult={handleChangeResult}
                                                                        toggleTableGlobalComment={toggleTableGlobalComment}
                                                                        modalTableGlobalComment={modalTableGlobalComment}
                                                                        method={method}
                                                                        handleCreateGlobalComment={handleCreateGlobalComment}
                                                                        toggleCrudComment={toggleCrudComment}
                                                                        modalCrudComment={modalCrudComment}
                                                                        saveCreate={saveCreate}
                                                                        handleInputChange={handleInputChange}
                                                                        text={text}
                                                                        type={type}
                                                                        comments={comments}
                                                                        handleInsert={handleInsert}
                                                                        handleDeleteCommentText={handleDeleteCommentText}
                                                                        loading={loading}
                                                                        search={search}
                                                                        setSearch={setSearch}
                                                                        keyComments={keyComments}

                                                                    />
                                                                })
                                                            }
                                                        </>
                                                        : null
                                                }
                                            </div>
                                        </>
                                    }
                                    <hr />
                                </>
                                :
                                examen.analytes.map((analyte, key4) => {
                                    return <InputAnalyte
                                        analyteData={analytes.find(x => x.id == analyte.id_analyte) !== undefined ? analytes.find(x => x.id == analyte.id_analyte) :
                                            {
                                                "id": "",
                                                "sub_id": curves.find(x => x.time.value === analyte.sub_id).time.value,
                                                "capture": "",
                                                "id_exam": "",
                                                "id_type_analyte": "",
                                                "id_exam_method": "",
                                                "decimals": "",
                                                "compute": "",
                                                "variable": "",
                                                "comment": "",
                                                "id_analyte_references": ""
                                            }
                                        }
                                        changeMethod={changeMethod}
                                        dataExam={examen}
                                        validateAnalyte={validateAnalyte}
                                        releaseData={releaseData}
                                        saveIndividualAnalyte={saveIndividualAnalyte} examMethod={examMethod} appCodeOrMethodExam={appCodeOrMethodExam} age={age} days_age={days_age} gender={gender} analyte={analyte} key={key4} idPat={idPat} namePatiente={namePatiente} nameP={nameP} surnameP={surnameP} surnameM={surnameM}
                                        dataCurve={curves.find(x => x.time.value === analyte.sub_id)}
                                        setChanged={setChanged}
                                        idWChart={idWChart}
                                    />
                                })
                            )
                        }
                        {
                            !canReport(examen.id_branch) && examen.isRelease &&
                            ((curves === null || curves === undefined) ?
                                <>
                                    {
                                        examen.analytes.map((analyte, key4) => {
                                            // console.log("🚀 ~ examen.analytes.map ~ analyte:", analyte)
                                            return <InputAnalyte
                                                analyteData={analytes.find(x => x.id == analyte.id_analyte) !== undefined ? analytes.find(x => x.id == analyte.id_analyte) :
                                                    {
                                                        "id": "",
                                                        "capture": "",
                                                        "id_exam": "",
                                                        "id_type_analyte": "",
                                                        "id_exam_method": "",
                                                        "decimals": "",
                                                        "compute": "",
                                                        "variable": "",
                                                        "comment": "",
                                                        "id_analyte_references": ""
                                                    }
                                                }
                                                changeMethod={changeMethod}
                                                dataExam={examen}
                                                validateAnalyte={validateAnalyte}
                                                releaseData={releaseData}
                                                saveIndividualAnalyte={saveIndividualAnalyte} examMethod={examMethod} appCodeOrMethodExam={appCodeOrMethodExam} age={age} days_age={days_age} gender={gender} analyte={analyte} key={key4} idPat={idPat} namePatiente={namePatiente} nameP={nameP} surnameP={surnameP} surnameM={surnameM}
                                                allCurves={"Esta entrando por aca"}
                                                setChanged={setChanged}
                                                idWChart={idWChart}
                                            />
                                        })
                                    }


                                    {
                                        examen.is_micro &&
                                        <>
                                            {
                                                // * PRESUMPTIVE
                                            }
                                            {
                                                _typeClient !== cedimi && <Row className={examen.presumptive_results?.length > 0 ? "d-none" : 'border-top pt-2 mt-2'}    >
                                                    <Col sm="12">
                                                        <h5>Resultado Preliminar</h5>
                                                        <button className='btn btn-warning' tabIndex="-1" onClick={() => addPresumptiveResult(examen?.id_work_order_exam, "section", examen?.id_exam, sectionProfileId)}>Nuevo Preliminar</button>
                                                    </Col>
                                                </Row>
                                            }
                                            {
                                                _typeClient !== cedimi && <div style={{ backgroundColor: "#51bb2536" }} >
                                                    {
                                                        examen?.presumptive_results !== undefined && examen?.presumptive_results !== null ?
                                                            <>
                                                                {
                                                                    examen?.presumptive_results?.length > 0 && examen?.presumptive_results.map((_presumtive, _key) => (
                                                                        <>
                                                                            <PresumptiveSave
                                                                                idExam={examen?.id_work_order_exam}
                                                                                presumptive={presumptive}
                                                                                handleChangePresumptive={handleChangePresumptive}
                                                                                presumptive2={presumptive}
                                                                                printingGlobal={printingGlobal}
                                                                                removePrintingGlobal={removePrintingGlobal}
                                                                                typeArray={typeArray}
                                                                                sectionProfileId={sectionProfileId}
                                                                                examId={examen.id_exam}
                                                                            />
                                                                            {
                                                                                _presumtive?.presumptives?.length > 0 && (
                                                                                    <PresumptiveResult
                                                                                        key={_presumtive?.presumptives[0]?.id_presumptive_result}
                                                                                        addPresumptiveResult={addPresumptiveResult}
                                                                                        setPresumptive={setPresumptive}
                                                                                        removePresumptiveResult={removePresumptiveResult}
                                                                                        idExam={examen?.id_work_order_exam}
                                                                                        position={_key}
                                                                                        presumptive={presumptive}
                                                                                        savePresuntive={_presumtive?.close_capture}
                                                                                        PrintingPresumptiveResult={PrintingPresumptiveResult}
                                                                                        cancelRemovePresumtiveResults={cancelRemovePresumtiveResults}
                                                                                        cancelPrintingPresumptive={cancelPrintingPresumptive}
                                                                                        typeArray={typeArray}
                                                                                        sectionProfileId={sectionProfileId}
                                                                                        examId={examen?.id_exam}
                                                                                        antibitic={examen}
                                                                                    />
                                                                                )
                                                                            }
                                                                        </>
                                                                    ))
                                                                }
                                                            </>
                                                            : null
                                                    }
                                                </div>
                                            }
                                            {
                                                _typeClient !== cedimi && <hr />
                                            }
                                            {
                                                // ? TYPE OF REPORT
                                            }
                                            {
                                                _typeClient === cedimi && <Row>
                                                    <Col sm="12" className='pb-4'>
                                                        <Row>
                                                            <Col sm="3">
                                                                <h5 className={examen?.cedimi_micro_type_result === false ? "txt-success" : ""}>Informe Preeliminar</h5>
                                                                <i
                                                                    style={examen?.id_estatus_exam === 4 || examen?.id_estatus_exam ? { filter: "opacity(0.5)" } : {}}
                                                                    className={examen?.cedimi_micro_type_result === false ? "fa fa-square f-26 icon-a-a txt-success" : "fa fa-square-o f-26 icon-a-a txt-success"} onClick={(e) => {
                                                                        if (examen?.id_estatus_exam === 4 || examen?.id_estatus_exam === 6) {
                                                                            e.preventDefault();
                                                                            return;
                                                                        }
                                                                        handleTypeResult(examen?.id_work_order_exam, is_profile === true ? "profile" : "section", examen?.id_exam, sectionProfileId, 0);
                                                                    }} ></i>
                                                            </Col>
                                                            <Col sm="3">
                                                                <h5 className={examen?.cedimi_micro_type_result === true ? "txt-success" : ""}>Informe Final</h5>
                                                                <i
                                                                    style={examen?.id_estatus_exam === 4 || examen?.id_estatus_exam === 6 ? { filter: "opacity(0.5)" } : {}}
                                                                    className={examen?.cedimi_micro_type_result === true ? "fa fa-square f-26 icon-a-a txt-success" : "fa fa-square-o f-26 icon-a-a txt-success"}
                                                                    onClick={(e) => {
                                                                        if (examen?.id_estatus_exam === 4 || examen?.id_estatus_exam === 6) {
                                                                            e.preventDefault();
                                                                            return;
                                                                        }
                                                                        handleTypeResult(examen?.id_work_order_exam, is_profile === true ? "profile" : "section", examen?.id_exam, sectionProfileId, 1);
                                                                    }}
                                                                ></i>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            }

                                            {
                                                // * BACTERIUM
                                            }
                                            <Row className="border-top pt-2 mt-2">
                                                <Col sm="12">
                                                    <button className='btn btn-success' tabIndex="-1" onClick={() => addMicroAislado(examen?.id_work_order_exam, "section", examen?.id_exam, sectionProfileId)}>Nuevo microorganismo</button>
                                                </Col>
                                            </Row>
                                            <div style={{ paddingBottom: 40 }}>
                                                {
                                                    examen?.bacteriums !== undefined && examen?.bacteriums !== null && examen?.bacteriums.length > 0 ?
                                                        <>
                                                            {
                                                                microBacteriums.map((_bacter, _keys) => {
                                                                    return <InputsMicro
                                                                        key={_bacter?.id_mic_bacterium}
                                                                        idExam={examen?.id_work_order_exam}
                                                                        examId={examen?.id_exam}
                                                                        position={_keys}
                                                                        is_profile={is_profile}
                                                                        sectionProfileId={sectionProfileId}
                                                                        listMicroBacteriums={microBacteriums}
                                                                        microBacteriums={_bacter}
                                                                        setMicroBacteriums={setMicroBacteriums}
                                                                        handleTypeBacterium={handleTypeBacterium}
                                                                        microAntibiograms={microAntibiograms}
                                                                        handleChangeComments={handleChangeComments}
                                                                        removeBacterium1={removeBacterium1}
                                                                        removeBacteriumAntibitic={removeBacteriumAntibitic}
                                                                        ValidateBacterium={ValidateBacterium}
                                                                        typeArray={typeArray}
                                                                        UnValidateBacterium={UnValidateBacterium}
                                                                        ReleaseBacterium={ReleaseBacterium}
                                                                        UnReleaseBacterium={UnReleaseBacterium}
                                                                        _typeClient={_typeClient}
                                                                        cedimi={cedimi}
                                                                        handleCreateGlobalComment={handleCreateGlobalComment}
                                                                        handleFullUnvalidate={handleFullUnvalidate}
                                                                    />
                                                                })
                                                            }
                                                        </>
                                                        : ""
                                                }
                                            </div>
                                            {
                                                // * GLOBAL COMMENT
                                            }
                                            <Row className={examen?.micro_global_comment?.length > 0 ? "d-none" : 'border-top pt-2 mt-2'}    >
                                                <Col sm="12">
                                                    <h5>Comentario Global</h5>
                                                    <button className='btn btn-dark' tabIndex="-1" onClick={() => addCommentGlobal(examen?.id_work_order_exam, "section", examen?.id_exam, sectionProfileId)}>Nuevo Comentario</button>
                                                </Col>
                                            </Row>
                                            <div style={{ paddingBottom: 40 }} >
                                                {
                                                    examen?.micro_global_comment !== undefined && examen?.micro_global_comment !== null ?
                                                        <>
                                                            {
                                                                microComments.map((_presumtive, _key) => (
                                                                    <>
                                                                        <ComponentCommentGlobal
                                                                            idExam={examen?.id_work_order_exam}
                                                                            microCommentss={microComments}
                                                                            typeArray={typeArray}
                                                                            sectionProfileId={sectionProfileId}
                                                                            examId={examen?.id_exam}
                                                                            handleChangeIsolated={handleChangeIsolated}
                                                                            valid={examen?.id_estatus_exam}
                                                                            handleChangeResult={handleChangeResult}
                                                                            toggleTableGlobalComment={toggleTableGlobalComment}
                                                                            modalTableGlobalComment={modalTableGlobalComment}
                                                                            method={method}
                                                                            handleCreateGlobalComment={handleCreateGlobalComment}
                                                                            toggleCrudComment={toggleCrudComment}
                                                                            modalCrudComment={modalCrudComment}
                                                                            saveCreate={saveCreate}
                                                                            handleInputChange={handleInputChange}
                                                                            text={text}
                                                                            type={type}
                                                                            comments={comments}
                                                                            handleInsert={handleInsert}
                                                                            loading={loading}
                                                                            search={search}
                                                                            setSearch={setSearch}
                                                                            keyComments={keyComments}
                                                                        />
                                                                    </>
                                                                ))
                                                            }
                                                        </>
                                                        : null
                                                }
                                            </div>



                                        </>
                                    }
                                </>
                                :
                                examen.analytes.map((analyte, key4) => {
                                    return <InputAnalyte
                                        analyteData={analytes.find(x => x.id == analyte.id_analyte) !== undefined ? analytes.find(x => x.id == analyte.id_analyte) :
                                            {
                                                "id": "",
                                                "sub_id": curves.find(x => x.time.value === analyte.sub_id).time.value,
                                                "capture": "",
                                                "id_exam": "",
                                                "id_type_analyte": "",
                                                "id_exam_method": "",
                                                "decimals": "",
                                                "compute": "",
                                                "variable": "",
                                                "comment": "",
                                                "id_analyte_references": ""
                                            }
                                        }
                                        changeMethod={changeMethod}
                                        dataExam={examen}
                                        validateAnalyte={validateAnalyte}
                                        releaseData={releaseData}
                                        saveIndividualAnalyte={saveIndividualAnalyte} examMethod={examMethod} appCodeOrMethodExam={appCodeOrMethodExam} age={age} days_age={days_age} gender={gender} analyte={analyte} key={key4} idPat={idPat} namePatiente={namePatiente} nameP={nameP} surnameP={surnameP} surnameM={surnameM}
                                        dataCurve={curves.find(x => x.time.value === analyte.sub_id)}
                                        setChanged={setChanged}
                                        idWChart={idWChart}
                                    />
                                })
                            )

                        }





                    </CardBody>

                </Card>


                <Sidebar
                    key={selectedExam?.id_exam || "empty"}
                    visible={visibleSidebar}
                    position="right"
                    onHide={() => setVisibleSidebar(false)}
                    className="sidebar-historico"
                    style={{ width: '35%' }}
                    maskClassName="mask-historico"

                >

                    {
                        loadingHistorico ? (
                            <div className="loader-container">
                                <div className="spinner"></div>
                                <p>Cargando histórico...</p>
                            </div>
                        ) :
                            !historicoRaw ? null :
                                (() => {

                                    const exam = historicoRaw.exams.find(e => e.id_exam === selectedExam?.id_exam);

                                    if (!exam) return null;

                                    const orders = getNimsData(historicoRaw, exam);
                                    console.log("🧁 historicoRaw", historicoRaw);


                                    return (
                                        <>

                                            <div className="historico-header">

                                                <div className="header-left">
                                                    <div className="icon-box">
                                                        <i className="pi pi-info-circle"></i>
                                                    </div>

                                                    <div className="exam-name">
                                                        {selectedExam?.name}
                                                    </div>
                                                </div>

                                                <div
                                                    className="close-btn"
                                                    onClick={() => setVisibleSidebar(false)}
                                                >
                                                    ✕
                                                </div>

                                            </div>

                                            <div className="historico-card mt-2">
                                                {
                                                    orders.length === 0 ? (
                                                        <div
                                                            style={{
                                                                padding: "20px",
                                                                textAlign: "center",
                                                                color: "#6b7280",
                                                                fontWeight: "500"
                                                            }}
                                                        >
                                                            Sin resultados para este examen
                                                        </div>
                                                    ) : (

                                                        <DataTable
                                                            value={historicoData}
                                                            key={selectedExam?.id_exam}
                                                            scrollable
                                                            scrollDirection="horizontal"
                                                            className="table-historico"
                                                            scrollHeight="flex"
                                                            rowClassName={(row) => {
                                                                if (row.tipo === "separador_micro") return "row-separador-micro";
                                                                if (row.tipo === "antibiograma") return "row-antibiograma";

                                                                if (row.tipo === "bacteria") return "row-bacteria";
                                                                if (row.tipo === "header") return "row-header";

                                                                const isChange = Object.keys(row).some(key => {
                                                                    if (!key.startsWith("nim_")) return false;

                                                                    const index = parseInt(key.split("_")[1]);
                                                                    const value = row[`nim_${index}`];
                                                                    const prev = row[`nim_${index + 1}`];

                                                                    return (
                                                                        value !== prev &&
                                                                        prev !== undefined &&
                                                                        value !== "-" &&
                                                                        prev !== "-"
                                                                    );
                                                                });

                                                                return isChange ? "row-cambio" : "";
                                                            }}
                                                        >


                                                            <Column
                                                                header="ANALITO"
                                                                frozen
                                                                alignFrozen="left"
                                                                style={{ minWidth: "125px", width: "155px" }}
                                                                headerClassName="th-left"
                                                                body={(row) => {

                                                                    if (row.tipo === "separador_micro") {
                                                                        return (
                                                                            <div className="micro-bar">
                                                                                {row.analito}
                                                                            </div>
                                                                        );
                                                                    }

                                                                    return (
                                                                        <span className="analito-cell">
                                                                            {row.analito}
                                                                        </span>
                                                                    );
                                                                }}

                                                            />

                                                            {
                                                                orders.map((order, index) => (
                                                                    <Column
                                                                        key={order.id_work_order}
                                                                        header={renderHeaderNim("NIM", order.nim)}
                                                                        body={(row) => {

                                                                            const value = row[`nim_${index}`];
                                                                            if (row.tipo === "separador_micro") return null;

                                                                            if (row.tipo === "antibiograma") {

                                                                                if (row.tipo === "antibiograma") {

                                                                                    if (!value || !value.bacterias || value.bacterias.length === 0) {
                                                                                        return <span className="value-cell-antibiagram">-</span>;
                                                                                    }

                                                                                    return (
                                                                                        <div className="cell-antibiograma">

                                                                                            <div className="abg-cards-container">

                                                                                                {
                                                                                                    value.bacterias.map((b, i) => (
                                                                                                        <div key={i} className="abg-card">

                                                                                                            <div className="abg-card-header">
                                                                                                                {b.label_mic_bacterium || "-"}
                                                                                                            </div>

                                                                                                            <div className="abg-card-body">

                                                                                                                <div className="abg-item">
                                                                                                                    <span className="abg-label">Gram:</span>
                                                                                                                    <span className={
                                                                                                                        b.label_mic_stain_gram === "POSITIVO"
                                                                                                                            ? "gram-positive"
                                                                                                                            : b.label_mic_stain_gram === "NEGATIVO"
                                                                                                                                ? "gram-negative"
                                                                                                                                : ""
                                                                                                                    }>
                                                                                                                        {b.label_mic_stain_gram || "-"}
                                                                                                                    </span>
                                                                                                                </div>

                                                                                                                <div className="abg-item">
                                                                                                                    <span className="abg-label">Cantidad númerica:</span>
                                                                                                                    <span>{b.quantity_number || "-"}</span>
                                                                                                                </div>

                                                                                                                <div className="abg-item">
                                                                                                                    <span className="abg-label">Cantidad texto:</span>
                                                                                                                    <span>{b.label_bacterium_count_text || "-"}</span>
                                                                                                                </div>
                                                                                                                {/* Descomentar si un cliente lo quiere en su historico en microclinica */}

                                                                                                                {/* <div className="abg-item">
                                                                                <span className="abg-label">Comentario:</span>
                                                                                <div className="abg-comment">
                                                                                    {b.comment_resistance_mechanism || "-"}
                                                                                </div>
                                                                            </div> */}

                                                                                                            </div>

                                                                                                        </div>
                                                                                                    ))
                                                                                                }

                                                                                            </div>

                                                                                        </div>
                                                                                    );
                                                                                }
                                                                            }

                                                                            const prev = row[`nim_${index + 1}`];

                                                                            const changed =
                                                                                value !== prev &&
                                                                                prev !== undefined &&
                                                                                value !== "-" &&
                                                                                prev !== "-";

                                                                            return (
                                                                                <span className={`value-cell ${changed ? 'danger' : ''}`}>
                                                                                    {value}
                                                                                </span>
                                                                            );
                                                                        }}
                                                                    />
                                                                ))
                                                            }

                                                        </DataTable>
                                                    )}

                                            </div>

                                        </>

                                    );
                                })()
                    }

                </Sidebar>

            </Col>
        </Row >

    )
}